import red from '@material-ui/core/colors/red';
import amber from '@material-ui/core/colors/amber';
import cameraLogo from 'SRC/assets/images/camera.svg';
import microphoneLogo from 'SRC/assets/images/microphone.svg';
import appLogo from 'SRC/assets/images/Acetiam-Icons-Blue-ic-teleconsultation.svg';
import titleLogo from 'SRC/assets/images/Acetiam-Icons-Blue-ic_administration.svg';
import { createMuiTheme } from '@material-ui/core';

const baseTheme = createMuiTheme({
  assets: {
    cameraLogo,
    microphoneLogo,
    appLogo,
    titleLogo,
    audioToneURL: 'http://codeskulptor-demos.commondatastorage.googleapis.com/GalaxyInvaders/bonus.wav',
  },
  typography: {
    fontFamily: '"Ubuntu", sans-serif',
    button: {
      letterSpacing: '1.25pt',
    },
  },
  palette: {
    primary: {
      main: '#4982CF',
    },
    secondary: {
      main: '#334880',
      dark: '#1B2550',
    },
    error: {
      main: red[500],
      light: red[100],
      dark: red[900],
    },
    warning: {
      main: amber[500],
      light: amber[100],
      dark: amber[900],
    },
    success: {
      light: '#d5f0e6',
      main: '#83bca7',
      dark: '#31a668',
    },
    info: {
      main: '#bed0e9',
    },
  },
});

const outlinedButtonRule = {
  borderWidth: '2px',
  '&:hover': {
    borderWidth: '2px',
  },
};

export const defaultTheme = createMuiTheme({
  ...baseTheme,
  overrides: {
    MuiTable: {
      root: {
        backgroundColor: baseTheme.palette.grey[100],
        border: `1px solid ${baseTheme.palette.grey[300]}`,
      },
    },
    MuiTableCell: {
      root: {
        borderBottomColor: baseTheme.palette.grey[300],
      },
    },
    MuiButton: {
      outlinedPrimary: outlinedButtonRule,
      outlinedSecondary: outlinedButtonRule,
      outlined: outlinedButtonRule,
    },
  },
});
console.log('defaultTheme', defaultTheme)
